<template>
  <AdminOverviewPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminOverviewPage from "shared-ui/pages/AdminOverviewPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_overview.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
